<template>
  <span>
    <b-btn
      class="mr-1"
      variant="outline-primary"
      size="sm"
      :title="$t('Assign roles')"
      @click="openModal">
      <i :title="$t('Assign roles')" class="fas fa-user-tag" />
    </b-btn>
    <b-modal
      :ref="refId"
      :no-enforce-focus="true"
      :no-close-on-backdrop="true"
      size="lg"
      centered
      @hidden="onHidden">
      <div slot="modal-title">
        <span style="font-size: 1.563rem">{{ $t('Assign roles') }}</span>
      </div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-multiselect
            :label-form="'Roles' | translate"
            class-form="col-12 mb-2"
            labelColsSm="2"
            labelColsLg="2"
            label-search="name"
            :is-required="false"
            :value="selectedRoles"
            :options="roleOptions"
            :placeholder="$t('Select one or more roles')"
            :min-length="0"
            @select="onSelect"
            @remove="onRemove"
            @clear="onClear" />
        </b-form-row>
      </b-form>
      <div slot="modal-footer">
        <b-btn class="mr-3" variant="default" @click.prevent="closeModal">
          {{ 'Cancel' | translate }}
        </b-btn>
        <b-btn variant="primary" :disabled="saving" @click.prevent="onSubmit">
          {{ 'Save' | translate }}
        </b-btn>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { mapActions } from 'vuex'
import { TYPES as USER_TYPES } from './store'

import FormThuxHorizontalMultiselect from '../../../components/form-thux-horizontal-components/FormThuxHorizontalMultiselect'

export default {
  name: 'ButtonAssignRoles',
  components: {
    'form-thux-horizontal-multiselect': FormThuxHorizontalMultiselect
  },
  props: { user: { required: true } },
  data () {
    return {
      refId: null,
      roleOptions: [],
      selectedIds: [],
      saving: false
    }
  },
  created () {
    this.refId = `assign-roles-${this.user.id}`
  },
  computed: {
    selectedRoles () {
      return this.roleOptions.filter((opt) => this.selectedIds.includes(opt.id))
    }
  },
  methods: {
    ...mapActions({
      setTeamRoles: USER_TYPES.GENERIC.account.user.DETAIL.ACTIONS.setTeamRoles,
      getTeamRoles: USER_TYPES.GENERIC.account.user.DETAIL.ACTIONS.getTeamRoles,
      getAllTeamRoles: USER_TYPES.GENERIC.account.user.DETAIL.ACTIONS.getAllTeamRoles
    }),
    openModal () {
      this.getRoles()
      this.$refs[this.refId].show()
    },
    closeModal () {
      this.$refs[this.refId].hide()
    },
    onHidden () {
      this.$set(this, 'selectedIds', [])
      this.$set(this, 'roleOptions', [])
    },
    getRoles () {
      this.getAllTeamRoles().then((results) => {
        this.$set(this, 'roleOptions', (results || []).map((role) => ({ id: role.id, name: role.name })))
      })
      this.getTeamRoles({ id: this.user.id }).then((results) => {
        this.$set(this, 'selectedIds', (results || []).map((role) => role.role))
      })
    },
    onSelect (item) {
      if (!this.selectedIds.includes(item.id)) this.selectedIds.push(item.id)
    },
    onRemove (item) {
      this.$set(this, 'selectedIds', this.selectedIds.filter((id) => id !== item.id))
    },
    onClear () {
      this.$set(this, 'selectedIds', [])
    },
    onSubmit () {
      this.$set(this, 'saving', true)
      this.setTeamRoles({ id: this.user.id, team_roles: this.selectedIds })
        .then(() => {
          this.closeModal()
          this.$emit('on-assign-roles')
        })
        .finally(() => {
          this.$set(this, 'saving', false)
        })
    }
  }
}
</script>
